import makeStyles from "@mui/styles/makeStyles";
export var useDialogStyles = makeStyles(function () { return ({
    root: {
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
}); });
